import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { STORAGE_KEYS } from '@/lib/config/constants';
import { uid } from '@/lib/utils/id';
import { useAuthStore } from '@/store/authStore';
import type { HeldSale, CartItem, Customer } from '@/types/domain';

interface HeldSalesState {
  list: HeldSale[];
  hold(label: string, items: CartItem[], customer: Customer | null): HeldSale;
  remove(id: string): void;
  get(id: string): HeldSale | undefined;
  clear(): void;
}

export const useHeldSalesStore = create<HeldSalesState>()(
  persist(
    (set, get) => ({
      list: [],
      hold: (label, items, customer) => {
        const held: HeldSale = {
          id: uid('hold'),
          userId: useAuthStore.getState().user?.id ?? null,
          label,
          items,
          customerId: customer?.id ?? null,
          customer: customer ?? null,
          createdAt: new Date().toISOString(),
        };
        set((s) => ({ list: [held, ...s.list].slice(0, 30) }));
        return held;
      },
      remove: (id) => set((s) => ({ list: s.list.filter((h) => h.id !== id) })),
      get: (id) => get().list.find((h) => h.id === id),
      clear: () => set({ list: [] }),
    }),
    {
      name: STORAGE_KEYS.heldSales,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
